window.addEventListener("load", function () {
  $(".custom-products_tab").click(function() {
    if (!$(this).hasClass("active")) {
      let index = $(this).index()
      let swiper_class_pc = $(this).data("swiper")+"_pc"
      let swiper_class_m = $(this).data("swiper")+"_m"
      $(this).siblings().removeClass("active")
      $(this).addClass("active")
      $(this).parents(".custom-products_tabs_section").find(".custom-products_tab_content").removeClass("active")
      $(this).parents(".custom-products_tabs_section").find(".custom-products_tab_content").eq(index).addClass("active")
      if (document.documentElement.clientWidth > 768) {
        initSwiper(swiper_class_pc)
      }else{
        initSwiper(swiper_class_m)
      }
    }
  })

let coll_wrapper = document.querySelectorAll(".toggle-dropdown-container")
     coll_wrapper.forEach((coll) => {
       console.log(coll.querySelector(".js-toggle-dropdown"))
       coll.querySelector(".js-toggle-dropdown").onclick = function() {
         this.parentElement.parentElement.classList.toggle("active")
       }
    });
})
function initSwiper(className) {
     new Swiper(`.${className}`,{
         slidesPerView: 1,
         spaceBetween: 10,

         breakpoints: {
           768: {
             slidesPerView: 3,
             spaceBetween: 15
           },
           1280: {
             slidesPerView: 3,
             spaceBetween: 20
           }
         },
         pagination: {
                      el: `.${className} .swiper-pagination`,
                    },
       navigation: {
          nextEl: `.${className} .swiper-button-next`,
          prevEl: `.${className} .swiper-button-prev`,
        },
       })
}
